import axios from "axios";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import UnauthorizedView from "components/UI/UnauthorizedView";
import { useAuth } from "hooks/useAuth";

const AtypicalFilesManager = () => {
  const [fileData, setFileData] = useState({});
  const [file, setFile] = useState({});
  const { authToken, csrfToken, permissions } = useAuth();

  if (permissions.role_type !== "NIAP") {
    return <UnauthorizedView />;
  }

  const handleChange = (event) => {
    setFileData({ ...fileData, [event.target.name]: event.target.value });
  };

  const handleFile = (event) => {
    setFile({ ...file, [event.target.name]: event.target.files[0] });
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const submittedData = new FormData();
      submittedData.append("file", file.file);
      submittedData.append("base_path", fileData.base_path);
      axios
        .post(
          `${import.meta.env.VITE_DJANGO_ENDPOINT}file/post_atypical_file/`,
          submittedData,
          {
            withCredentials: true,
            headers: {
              "X-CSRFToken": csrfToken,
              Authorization: `Token ${authToken}`,
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          const link = response.data.file_link;
          setFileData({ ...fileData, link: link });
        })
        .catch((error) => {
          console.log("Upload Error", error);
        });
    }
  };

  return (
    <Container>
      <Row>
        <Col xs={12} className="text-center">
          <h2>Upload Atypical File</h2>
        </Col>
      </Row>
      {fileData?.link && (
        <Row>
          <Col xs={12}>
            <h3>
              <a href={fileData.link} target="_blank" rel="noreferrer">
                {fileData.link}
              </a>
            </h3>
          </Col>
        </Row>
      )}
      <Form onSubmit={handleSubmit} aria-label="upload-file">
        <Row className="mb-3">
          <Col xs={12}>
            <Form.Group controlId="base_path">
              <Form.Label>Select the Base Path*</Form.Label>
              <Form.Select
                name="base_path"
                onChange={handleChange}
                required={true}
              >
                <option value={""}>Select a Path</option>
                <option value={"Documents_and_Guidance"}>
                  Documents_and_Guidance
                </option>
                <option value={"Policy"}>Policies</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12}>
            <Form.Group controlId="file">
              <Form.Label>Select a File*</Form.Label>
              <Form.Control
                type="file"
                name="file"
                onChange={handleFile}
                required={true}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12}>
            <Button
              type="submit"
              onClick={handleSubmit}
              className="me-2"
              disabled={!file?.file || !fileData?.base_path}
            >
              Upload File
            </Button>
            <Button type="reset">Cancel</Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default AtypicalFilesManager;
